module.exports = __webpack_public_path__ + "img/tiktok_extension.0fd3b1a6.gif";